import React from "react";
import SupportUs from "../../containers/SupportUs/SupportUs";
import { Helmet } from "react-helmet";

const Support = () => {
  return (
    <>
      <Helmet>
        <title>ถวาย - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <SupportUs />
    </>
  );
};

export default Support;
